import { useEffect, useState } from "react";
import { getCSSVariableValue } from "../../../_uLearn/assets/ts/_utils";
import Method from "../../../utils/methods";
import DatePicker from "react-datepicker";
import { Card, Col, Row } from "react-bootstrap";
import { DashboardString } from "../../../utils/string";
import APICallService from "../../../api/apiCallService";
import { dashBoardEndPoints } from "../../../api/apiEndPoints";
import Loader from "../../../Global/loader";
import { Link, useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import { error } from "../../../Global/toast";
import "react-datepicker/dist/react-datepicker.css";

const Vendors = (props: any) => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState<any>(
    Method.getCurrentMonthStartDate()
  );
  const [endDate, setEndDate] = useState<any>(Method.getCurrentMonthEndDate());
  const [loading, setLoading] = useState(true);
  const [vendorsData, setVendorsData] = useState<any>({ data: [] });
  const baseColor = getCSSVariableValue("--bs-primary");

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchRegisterVendor(startDate, endDate);
      setLoading(false);
    })();
  }, []);

  const fetchRegisterVendor = async (startDate: any, endDate: any) => {
    setLoading(true);
    const params: any = {};
    if (startDate) {
      params.fromDate = Method.convertDateToFormat(startDate, "YYYY-MM-DD");
    }
    if (endDate) {
      params.toDate = Method.convertDateToFormat(endDate, "YYYY-MM-DD");
    }
    const apiService = new APICallService(
      dashBoardEndPoints.VENDORS_COUNT,
      params
    );
    const response = await apiService.callAPI();

    if (response && response.data) {
      response.data = response.data.map((item: any) => {
        return {
          ...item,
          date: item.date.split("T")[0],
        };
      });
      setVendorsData(response);
    } else {
      setVendorsData({ data: [] });
    }
    setLoading(false);
  };

  const handleChange = async (event: any) => {
    setStartDate(event[0]);
    setEndDate(event[1]);
    const startMonth = Method.getMonth(
      Method.convertDateToFormat(event[0], "YYYY-MM-DD"),
      "MM"
    );
    const endMonth = Method.getMonth(
      Method.convertDateToFormat(event[1], "YYYY-MM-DD"),
      "MM"
    );
    const startDateFormatted =
      event[0] && event[1]
        ? Method.convertDateToFormat(event[0], "YYYY-MM-DD")
        : "";
    const endDateFormatted =
      event[0] && event[1]
        ? Method.convertDateToFormat(event[1], "YYYY-MM-DD")
        : "";
    if (event[0] && event[1]) {
      if (Method.dayDifference(event[0], event[1]) >= 6) {
        await fetchRegisterVendor(startDateFormatted, endDateFormatted);
      } else {
        error("Please select a date range with a minimum one-week difference");
      }
    } else if (event[0] === null && event[1] === null) {
      setStartDate(Method.getCurrentMonthStartDate());
      setEndDate(Method.getCurrentMonthEndDate());
      await fetchRegisterVendor(
        Method.getCurrentMonthStartDate(),
        Method.getCurrentMonthEndDate()
      );
    }
  };

  const data = vendorsData.data || [];
  const receivedFeesData = data.map((item: any) => item.vendorRegister);
  const categories = data.map((item: any) =>
    Method.convertDateToFormat(item.date, "MMM D")
  );

  if (data.length === 1) {
    // categories.push(categories[0]); // Duplicate the single date
    receivedFeesData.push(receivedFeesData[0]); // Duplicate the single value
  }

  //   const yAxisMin = Math.min(...receivedFeesData, 0);
  //   const yAxisMax =
  //     receivedFeesData.length > 0 ? Math.max(...receivedFeesData) * 1.2 : 10;

  return (
    <Card className="mb-7 bg-f9f9f9">
      <Card.Header className="pt-4 border-bottom-0">
        <div className="card-title">
          <h2 className="fs-22 fw-bolder">
            {DashboardString.RegisteredVendor}
          </h2>
        </div>
        <div className="card-toolbar">
          <Row className="align-items-center">
            <Col xs>
              <DatePicker
                className="form-control bg-white min-h-60px fs-15 fw-bold text-dark min-w-md-288px min-w-225px"
                selected={startDate}
                onChange={handleChange}
                selectsRange
                startDate={startDate}
                endDate={endDate}
                dateFormat="dd/MM/yyyy"
                showFullMonthYearPicker
                isClearable={true}
                showYearDropdown={true}
                scrollableYearDropdown={true}
                dropdownMode="select"
              />
            </Col>
          </Row>
        </div>
      </Card.Header>
      {!loading ? (
        <Card.Body className="pb-0">
          {vendorsData?.data?.length > 0 ? (
            <>
              <Chart
                options={{
                  chart: {
                    fontFamily: "inherit",
                    type: "area",
                    height: 350,
                    toolbar: {
                      show: false,
                    },
                    dropShadow: {
                      enabled: false,
                      color: "#1b74e4",
                      top: 0,
                      left: 0,
                      blur: 0,
                      opacity: 0.2,
                    },
                    zoom: {
                      enabled: false, // Disable zooming
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: "smooth",
                    show: true,
                    width: 3,
                    colors: [baseColor],
                  },
                  legend: {
                    show: false,
                  },
                  xaxis: {
                    categories: categories,
                    axisBorder: {
                      show: false,
                    },
                    axisTicks: {
                      show: false,
                    },
                    labels: {
                      style: {
                        colors: "#231f20",
                        fontWeight: "500",
                        fontSize: "13px",
                      },
                    },
                    tooltip: {
                      enabled: false,
                    },
                  },
                  yaxis: {
                    min: 0,
                    labels: {
                      align: "center",
                      style: {
                        colors: "#231f20",
                        fontWeight: "500",
                        fontSize: "13px",
                      },
                      formatter: function (y: any) {
                        return parseInt(y).toString();
                      },
                    },
                  },
                  tooltip: {
                    enabled: true,
                    custom({ series, seriesIndex, dataPointIndex, w }) {
                      const receivedFees =
                        vendorsData?.data[dataPointIndex]?.vendorRegister;
                      const dataDate = vendorsData?.data[dataPointIndex]?.date;
                      if (receivedFees === undefined || receivedFees === null) {
                        return "";
                      }
                      return (
                        '<div class="card fs-16 p-3 w-md-125px border-0">' +
                        "<div>" +
                        '<div class="fw-500">' +
                        Method.convertDateToFormat(dataDate, "DD MMM YYYY") +
                        "</div>" +
                        "<div>" +
                        '<span class="d-inline-block w-10px h-10px rounded-circle me-3" style="background-color:#a435f0;"></span>' +
                        Method.convertToMillions(receivedFees) +
                        "</span>" +
                        "</div>" +
                        "</div>" +
                        "</div>"
                      );
                    },
                  },
                  colors: [baseColor],
                  grid: {
                    borderColor: "#e0e0df",
                    strokeDashArray: 5,
                    yaxis: {
                      lines: {
                        show: true,
                      },
                    },
                  },
                  fill: {
                    type: "solid",
                    opacity: 0.05,
                  },
                  markers: {
                    size: 0,
                    colors: undefined,
                    strokeColors: baseColor,
                    shape: "circle",
                    strokeWidth: 8,
                    strokeOpacity: 1,
                    strokeDashArray: 0,
                    radius: 0,
                    onClick: undefined,
                    onDblClick: undefined,
                    showNullDataPoints: false,
                    hover: {
                      size: undefined,
                      sizeOffset: 3,
                    },
                  },
                }}
                series={[
                  {
                    name: "Received Fees",
                    data: receivedFeesData,
                    color: baseColor,
                  },
                ]}
                height={350}
                type="area"
              />
            </>
          ) : (
            <div className="d-flex justify-content-center min-h-100px pt-2">
              <span className="fs-18 fw-medium">
                No details available for these dates.
              </span>
            </div>
          )}
        </Card.Body>
      ) : (
        <Card.Body className="min-h-200px">
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        </Card.Body>
      )}
    </Card>
  );
};

export default Vendors;
